import dayjs from "dayjs"

import { IShippingSchedule } from "@/types/IBulkOrder"
import { ITableColumn } from "@/types/ui"

export const shippingSheduleColumns: ITableColumn<IShippingSchedule>[] = [
    {
        title: "Период отгрузки",
        key: "period",
        dataIndex: ["period"],
        isVisible: true,
        order: 1,
        render: (_, { startDate, endDate }) => `${dayjs(startDate).format("DD.MM.YYYY")} - ${dayjs(endDate).format("DD.MM.YYYY")}`
    },
    {
        title: "Тип топлива",
        key: "fuelTypeName",
        dataIndex: ["fuelTypeName"],
        isVisible: true,
        order: 2
    },
    {
        title: "Доступно к отгрузке",
        key: "remainderFuel",
        dataIndex: ["remainderFuel"],
        isVisible: true,
        order: 3
    },
    {
        title: "Всего к отгрузке",
        key: "quantity",
        dataIndex: ["quantity"],
        isVisible: true,
        order: 4
    },
    {
        title: "Цена, руб",
        key: "price",
        dataIndex: ["price"],
        isVisible: true,
        order: 5,
        render: (_, { price, lastSetPrice }) => price ? price : lastSetPrice
    }
]